import { DataTableColumnHeader } from "@/components/ui";
import { type AvailablePhoneNumber } from "@/lib/types/Firm";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<AvailablePhoneNumber>();

export const searchPhoneNumberTableColumns = [
  columnHelper.accessor("friendlyName", {
    id: "Display Number",
    enableHiding: false,
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  columnHelper.accessor("number", {
    id: "Full Number",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  columnHelper.accessor("locality", {
    id: "City",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  columnHelper.accessor("region", {
    id: "State",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),

  columnHelper.accessor("postalCode", {
    id: "Postal Code",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
];
